module.exports = __webpack_public_path__ + "img/جیب-دار.6c0dfbca.png";